<template>
  <div class="navbar-container main-menu-content">
    <horizontal-nav-menu-items :items="navMenuItems" />
  </div>
</template>

<script>
import navMenuItems from '@/navigation/horizontal'
import HorizontalNavMenuItems from './components/horizontal-nav-menu-items/HorizontalNavMenuItems.vue'

export default {
  components: {
    HorizontalNavMenuItems,
  },
  computed: {
    navMenuItems() {
      const showUpgrade = this.$store.getters['auth/showPremiumUpgrade']
      return navMenuItems.map(item => (item.children ? {
        ...item,
        children: item.children.filter(child => child.route !== 'learn-more-premium' || showUpgrade),
      } : item))
    },
  },
}
</script>

<style lang="scss">
@import "~@core/scss/base/core/menu/menu-types/horizontal-menu.scss";
</style>
